import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import { BottomNextButton } from "components/common/BottomNextButton";
import CustomTypography from "components/common/CustomTypography";
import { useMutation } from "@tanstack/react-query";
import { useRecoilValue } from "recoil";
import { taskApi } from "api";
import useRefetchTaskList from "../../../../hooks/useRefetchTaskList";
import { patientAtom } from "../../../../recoil/patientAtom";
import useClose from "../../../../hooks/useClose";

export default function Motivation_PS_8() {
  const refetchTaskList = useRefetchTaskList();

  const patient = useRecoilValue(patientAtom);
  const close = useClose();
  const refetchTaskListAndOpenSidebar = () => {
    refetchTaskList();
  };

  const { mutate: activityDone, isLoading: isActivityDoneLoading } =
    useMutation(
      async () => {
        return taskApi.done(`0-11-A:${patient?.patientId}`);
      },
      {
        onSuccess: () => {
          setTimeout(() => {
            refetchTaskListAndOpenSidebar();
          }, 1000);
          close();
        },
        onError: (error) => {
          console.error("Activity done failed:", error);
        },
      }
    );

  const handleNext = () => {
    activityDone();
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          {"삶은 우리가 느끼는 괴로움보다 훨씬 큽니다."}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {"언젠가부터 나의 삶은 괴로움과의 사투로 전락하고 말았습니다."}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {"내 삶의 소중한 것들은 어디 간 것일까요?"}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {
            "우린 앞으로 프로그램을 통해 나의 가치를 하나씩 발견하며 풍요로운 삶을 꾸려나갈 겁니다."
          }
        </CustomTypography>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"마치기"}
        highlightBackground={true}
        loading={isActivityDoneLoading}
      />
    </Box>
  );
}
